import { render, staticRenderFns } from "./Promo.vue?vue&type=template&id=646e3c4e"
import script from "./Promo.vue?vue&type=script&lang=js"
export * from "./Promo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports